const defaultData = {
  card1: true,
  card2: true,
  card3: true,
  card4: true,
  card5: true,
  card6: true,
  card7: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

const initialState = window.localStorage.getItem("cards-indicators-call-center")
  ? getDataFromStorage(
      JSON.parse(window.localStorage.getItem("cards-indicators-call-center")),
      defaultData
    )
  : defaultData;

const cardsOfCallCenterIndicators = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_CARDS_INDICATORS_CALL_CENTER":
      return {
        card1: action.card1,
        card2: action.card2,
        card3: action.card3,
        card4: action.card4,
        card5: action.card5,
        card6: action.card6,
        card7: action.card7,
      };
    default:
      return state;
  }
};

export default cardsOfCallCenterIndicators;
